import api from './api';
import type { Event } from './events';

// Sessão 1 Frente A — endpoints §6.1 do PLANO
// IMPORTANTE: paths usam '/admin/...' SEM prefix '/api/v1/' (Erro 73 — baseURL
// já carrega o prefix). Escrever '/api/v1/admin/...' = double-prefix → 404.

export type AttackCategory =
  | 'PACKET_SNIFFER'
  | 'MEMORY_HACK'
  | 'DEBUGGER'
  | 'INJECTION'
  | 'GAME_TAMPERING'
  | 'KERNEL_TOOLING'
  | 'RECON'
  | 'OVERLAY'
  | 'TIMING'
  | 'INTEGRITY'
  | 'UNKNOWN';

export type IncidentStatus =
  | 'open'
  | 'reviewed_ok'
  | 'reviewed_fp'
  | 'escalated'
  | 'auto_acted_pending_review'
  | 'resolved';

export type ReviewVerdict = 'ok' | 'fp' | 'escalate';

export interface Incident {
  id: string;                              // uuid externo
  session_id: number;                      // FK interno
  hwid: string;
  account_id: string;
  source_ip: string;
  attack_category: AttackCategory;
  severity_max: number;
  event_count: number;
  occurrence_sum: number;
  first_seen_at: string;
  last_seen_at: string;
  bucket_hour?: string;
  summary?: string;
  evidence_event_ids: number[];
  recommended_action?: string;
  status: IncidentStatus;
  reviewed_by_user_id?: number;
  reviewed_at?: string;
  reviewed_notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface IncidentListFilter {
  status?: IncidentStatus;
  attack_category?: AttackCategory;
  severity_min?: number;
  severity_max?: number;
  hwid?: string;
  account_id?: string;
  source_ip?: string;
  cursor?: number;
  limit?: number;
}

export interface IncidentListResponse {
  data: Incident[];
  next_cursor: number;
}

export interface IncidentDetail extends Incident {
  evidence_events: Event[];
}

export interface ReviewInput {
  verdict: ReviewVerdict;
  notes?: string;
}

export async function listIncidents(filter: IncidentListFilter = {}): Promise<IncidentListResponse> {
  const resp = await api.get<IncidentListResponse>('/admin/incidents', {
    params: {
      status: filter.status,
      category: filter.attack_category,
      severity_min: filter.severity_min,
      severity_max: filter.severity_max,
      hwid: filter.hwid,
      account_id: filter.account_id,
      source_ip: filter.source_ip,
      cursor: filter.cursor || 0,
      limit: filter.limit || 50,
    },
  });
  return resp.data;
}

export async function getIncident(uuid: string): Promise<IncidentDetail> {
  const resp = await api.get<IncidentDetail>(`/admin/incidents/${uuid}`);
  return resp.data;
}

export async function reviewIncident(uuid: string, input: ReviewInput): Promise<Incident> {
  const resp = await api.post<Incident>(`/admin/incidents/${uuid}/review`, input);
  return resp.data;
}

// Endpoint Sessions extension (Sessão 1 §6.6)
export async function listIncidentsBySession(sessionUuid: string): Promise<{ data: Incident[] }> {
  const resp = await api.get<{ data: Incident[] }>(`/admin/sessions/${sessionUuid}/incidents`);
  return resp.data;
}
